// extracted by mini-css-extract-plugin
module.exports = {"cover":"OpacityCover_cover__chHQo","fadein":"OpacityCover_fadein__d0AEs","closing":"OpacityCover_closing__figyv","fadeout":"OpacityCover_fadeout__0k2c_"};